<template>
    <div>
        <div class="ecaps-sidemenu-area">

            <div class="ecaps-logo">
                <router-link :to="'/'">

                    <template>
                        <img class="desktop-logo" :src="ruta + '/img/core-img/logo2.png'" alt="Desktop Logo">
                    </template>

                    <template>
                        <img class="small-logo" :src="ruta + '/img/core-img/favicon.png'" alt="Mobile Logo">
                    </template>

                </router-link>
            </div>


            <Sidebar @importExcelA="abrilModalImpotarExcel()" :ruta="ruta" :listPermisos="listRolPermisosByUsuario"
                :usuario="authUser"></Sidebar>

        </div>
        <div class="ecaps-page-content">

            <header class="top-header-area d-flex align-items-center justify-content-between">
                <div class="left-side-content-area d-flex align-items-center">

                    <div class="mobile-logo mr-3 mr-sm-4">
                        <router-link :to="'/'"><img :src="ruta + '/img/core-img/favicon.png'"
                                alt="Mobile Logo"></router-link>
                    </div>


                    <div class="ecaps-triggers mr-1 mr-sm-3">
                        <div class="menu-collasped" id="menuCollasped">
                            <i class="fas fa-bars"></i>
                        </div>
                        <div class="mobile-menu-open" id="mobileMenuOpen">
                            <i class="fas fa-bars"></i>
                        </div>
                    </div>



                </div>

                <Navbar :ruta="ruta" :usuario="authUser"></Navbar>
            </header>
            <div class="main-content">

                <transition name="slide-fade" mode="out-in">

                    <router-view :ruta="ruta" :usuario="authUser" :iva_data="iva_data"></router-view>

                </transition>

            </div>


        </div>


        <div class="modal fade " :class="{ show: modalShowExcel }"
            :style="modalShowExcel ? mostrarModal : 'ocultarModal'">
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16">Importar Cotizaciones - Excel</h5>
                        <button type="button" @click="abrilModalImpotarExcel()" class="close" data-dismiss="modal"
                            aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName">Archivo Excel</label>
                                    <input vue-load-file @change="fileUploadeExcel" class="form-control" type="file"
                                        id="file_import" accept=".XLSX">

                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName" class="text-danger"><b>Nota*</b></label>
                                    <p>- Solo se permiten archivos Excel de formato <b>.xlsx</b>, Click
                                        <a href="/cotizacion/exportar" download>aquÍ</a> para descargar archivo modelo.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="importarExcel()" class="btn btn-sm btn-primary">Guardar</button>
                        <button type="button" class="btn btn-sm btn-secondary"
                            @click="abrilModalImpotarExcel()">Cerrar</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>

    </div>
</template>

<script>
import Navbar from './plantilla/Navbar';
import Sidebar from './plantilla/Sidebar';
import { alertasM } from '../../js/util.js';

export default {
    props: ['ruta', 'usuario', 'iva_data'],
    components: { Navbar, Sidebar },
    mixins: [alertasM],
    data() {
        return {
            authUser: this.usuario,
            listRolPermisosByUsuario: [],
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            modalShowExcel: false,
            excel_cotizacion: '',
        }
    },
    methods: {

        abrilModalImpotarExcel() {
            let me = this;
            me.modalShowExcel = !this.modalShowExcel;
            if (me.modalShowExcel != true) {
                me.excel_cotizacion = '';
                $("#file_import").val('');
            }
        },

        importarExcel() {

            let me = this;
            let formData = new FormData();
            formData.append('file', me.excel_cotizacion);
            this.openCargando();
            var url = '/cotizacion/import';
            //Hacemos la peticion
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    this.openCargando(true);
                    var respuesta = res.data;
                    me.excel_cotizacion = '';
                    $("#file_import").val('');
                    if (respuesta.status) {
                        //me.$notie.alert(1, 'Requerimientos Importados Correctamente', 3);
                        this.notify("Cotizacion importada correctamente", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')

                        me.abrilModalImpotarExcel();

                    } else {
                        this.notify("Error al importar las cotizaciones ", "", "top", "center", "fas fa-check-circle", "success", ' flipInX', 'flipOutX')
                    }

                })
                .catch(err => {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    for (var key in err.response.data.errors) {
                        this.notify(" " + err.response.data.errors[key], "", "top", "right", "fas fa-exclamation-triangle", "danger", 'animated flipInX', 'flipOutX')

                    }
                    if (err.response.status == 401) {
                        this.$router.push({ name: 'login' })
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    console.error(err);
                })

        },

        fileUploadeExcel(e) {
            let me = this;
            let file_input = e.target.files[0];
            me.excel_cotizacion = file_input
        },
    },
    mounted() {

        this.listRolPermisosByUsuario = JSON.parse(localStorage.getItem('listRolPermisosByUsuario'));

        EventBus.$on('verifyAuthenticatedUser', data => {
            this.authUser = data;
        })
        EventBus.$on('notifyRolPermisosByUsuario', data => {
            this.listRolPermisosByUsuario = data;
        })

    },

}

</script>
